import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, NgZone } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, NgForm, Validators } from '@angular/forms';

import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { EntityService } from 'src/app/_core/entity.service';
import { SharedOrderCreateComponent } from 'src/app/shared-order/shared-order-create/shared-order-create.component';

import * as _ from 'lodash';
declare const $: any;

@Component({
    selector: 'app-tabitpay-enter-order',
    templateUrl: './tabitpay-enter-order.component.html',
    styleUrls: ['./tabitpay-enter-order.component.scss'],
    standalone: false
})
export class TabitpayEnterOrderComponent implements OnInit, OnDestroy {
    @Input() options;
    @Output() enterOrder = new EventEmitter<any>();
    @Output() loadOrder = new EventEmitter<any>();

	$storage: any;
	orderNO: string;
	tableId: string;
	newOrderId: string;
	workMode = 'default';
	subMode = 'general';
	tableTitle: string;


	public contactForm;
	public verificationForm;
	public canCreateTabOrder;
	public canCreateEatinOrder;

    constructor(
		public appService: AppService,
		public entityService: EntityService,
		public tabitPayService: TabitPayService,
		public dialog: MatDialog,
		public dialogsService: DialogsService
    ) {
		this.$storage = this.tabitPayService.$storage;

		this.canCreateEatinOrder = this.$storage.site.eatin?.enabled;
		this.canCreateTabOrder = this.$storage.site.tabitpay?.enableCreateTabOrder;
		this.tableId = this.appService.urlParams?.tableId;

		if (this.tableId) {
			this.contactForm = new UntypedFormGroup({
				phone: new UntypedFormControl(localStorage.getItem("c_phone"), [Validators.required]),
				name: new UntypedFormControl(localStorage.getItem("c_name"), [Validators.required]),
				orderNO: new UntypedFormControl('', [Validators.required]),
			});
			this.verificationForm = new UntypedFormGroup({
				verificationCode: new UntypedFormControl('', [Validators.required]),
			});

			this.workMode = 'table';
		} else if (this.canCreateTabOrder) {
			if (this.appService.urlParams.table) {
				this.tableTitle = this.appService.translate('OAT.table_no', { v: this.appService.urlParams.table });
			}
		}
    }

    ngOnInit() {

	}

	onOrderNoChange(newValue) {
		this.orderNO = newValue.toUpperCase();
	}

    ngOnDestroy() {

    }

    lookUpOrder(ev?) {
        this.enterOrder.emit(this.orderNO);
	}

	startTabOrder(ev?) {
		if (!this.checkEatinOrder()) return;
		if (!this.tabitPayService.canCreateTabOrder(this.$storage.site)) {
			this.appService.alert({html: this.appService.translate('TD.service_unavailable')}).then();
			return false;
		}
		this.dialogsService.showTabOrderOptions({actions:[]}).then();
	}

	createEatInOrder() {
		if (!this.checkEatinOrder()) return;
		this.appService.createEatinOrder(true);
	}


	checkEatinOrder(ev?) {
		if (!this.tabitPayService.canCreateEatinOrder()) {
			this.appService.alert({html: this.appService.translate('TD.service_unavailable')}).then();
			return false;
		}
		return true;
	}

	//----------------------------------------------------------->

	createTableOrder() {
		this.dialogsService.signInPrompt(this.$storage.contact, 'tableOrderCreate').then(() => {
			this.subMode = 'create';
			this.contactForm.controls.orderNO.clearValidators();
			this.contactForm.updateValueAndValidity();
		}).catch(err => {

		});
	}

	joinTableOrder() {
		this.dialogsService.signInPrompt(this.$storage.contact, 'tableOrderJoin').then(() => {
			this.subMode = 'join';
			this.contactForm.controls.orderNO.setValidators([Validators.required]);
			this.contactForm.updateValueAndValidity()
		}).catch(err => {

		});
	}

	applyTableOrder() {
		const payload = this.contactForm.value;
		this.newOrderId = this.appService.getObjectId();
		if (!this.contactForm.valid) {
			this.contactForm.get("phone").markAsTouched({ onlySelf: true });
			this.contactForm.get("name").markAsTouched({ onlySelf: true });
			this.contactForm.get("orderNO").markAsTouched({ onlySelf: true });
			return;
		}

		localStorage.setItem('c_phone', payload.phone);
		localStorage.setItem('c_name', payload.name);

		if (this.subMode = 'create') {
			this.lookUpTable(payload);
		} else {
			this.enterOrder.emit(payload.orderNO);
		}

	}

	applyTableOrderVerification() {
		const payload = this.contactForm.value;
		if (!this.verificationForm.valid) {
			this.verificationForm.get("verificationCode").markAsTouched({ onlySelf: true });
			return;
		}
		this.lookUpTable(payload, this.verificationForm.value.verificationCode);
	}

	resendPinCode() {
		this.verificationForm.controls.verificationCode.setValue("");
		this.lookUpTable(this.contactForm.value);
	}

	enteredPhone;

	lookUpTable(_payload, verificationCode?) { //task: 37785
		this.appService.blockUI.start();
		const params = this.appService.urlParams;
		this.enteredPhone = _payload.phone;
		let payload: any = { _id: this.newOrderId, orderer: _payload, onlineSource: { name: "At Table" } }
		if (verificationCode) {
			payload.verificationCode = verificationCode;
		}

		return this.entityService.post(`/online-shopper/tables/${this.tableId}/orders`, payload, { 'ros-organization': params.site }).then(res => {
			const orderId = _.get(res, '_id');
			return this.entityService.servicePost({
				url: `/online-shopper/orders/${orderId}/handoff`,
				data: {status: 'ready',},
				loadingCaption: 'PAYMENT_IN_PROGRESS'
			}).then(res => {
				this.appService.urlParams.oid = orderId;
				this.reloadOrder(params, orderId)
			});
			//this.appService.addItemsToOrder();
		}).catch(err => {
			//409144
			this.appService.blockUI.stop();
			const errorCode = err?.error?.code;

			let message;
			switch (errorCode) {
				case 409144:
					this.subMode = 'verification';
					return;
				case 409026:
					message = '_TABLEO.order_forphone_exist'
					break;

			}
			let oid = _.get(err, 'error.data.occupyingOrders[0]');
			if (oid) {
				if (message) {
					this.appService.alert({ content: message }).then(() => {
						this.reloadOrder(params, oid);
					});
				} else {
					this.reloadOrder(params, oid);
				}
			} else {
				if (!message) message = '_TABLEO.err_creating_table_order';
				this.appService.alert({ content: '_TABLEO.err_creating_table_order' });
			}

		});
	}

	reloadOrder(params, orderId) {
		document.location.replace(`${document.location.origin}/?site=${params.site}&oid=${orderId}`);
	}

	login() {
		this.dialogsService.login(this.$storage.contact);
	}

}
